import React from "react";
import ShortTextQuestion from "./ShortTextQuestion";
import LongTextQuestion from "./LongTextQuestion";
import BooleanQuestion from "./BooleanQuestion";
import TrueFalseQuestion from "./TrueFalseQuestion";
import SingleChoiceQuestion from "./SingleChoiceQuestion";
import MultiChoiceQuestion from "./MultiChoiceQuestion";
import RatingQuestion from "./RatingQuestion";
import AgreeDisagreeQuestion from "./AgreeDisagreeQuestion";
import ImageQuestion from "./ImageQuestion";
import CheckboxQuestion from "./CheckboxQuestion";
import PhoneQuestion from "./PhoneQuestion";

const COMPONENTS = {
  short_text: ShortTextQuestion,
  long_text: LongTextQuestion,
  boolean: BooleanQuestion,
  true_false: TrueFalseQuestion,
  single_choice: SingleChoiceQuestion,
  multi_choice: MultiChoiceQuestion,
  rating: RatingQuestion,
  agree_disagree: AgreeDisagreeQuestion,
  image: ImageQuestion,
  checkbox: CheckboxQuestion,
};

const IMMEDIATE_TYPES = new Set([
  "boolean",
  "true_false",
  "single_choice",
  "multi_choice",
  "rating",
  "agree_disagree",
  "image",
  "checkbox",
]);

/**
 * Render a question by type.
 *
 * @param {Object} props
 * @param {object} props.question
 * @param {unknown} props.value
 * @param {function(unknown, {{ immediate: boolean }}): void} props.onChange
 * @param {string} [props.error]
 * @param {boolean} [props.readOnly]
 * @param {boolean} [props.showRequired]
 * @returns {JSX.Element|null}
 */
export default function QuestionRenderer({
  question,
  value,
  onChange,
  error,
  readOnly,
  showRequired,
}) {
  if (question?.type === "short_text" && question.inputType === "phone") {
    return (
      <PhoneQuestion
        question={question}
        value={value}
        error={error}
        readOnly={readOnly}
        showRequired={showRequired}
        onChange={(next, meta) =>
          onChange(next, { immediate: meta?.immediate ?? false, uploading: Boolean(meta?.uploading) })
        }
      />
    );
  }
  const Component = COMPONENTS[question?.type];
  if (!Component) return null;
  const immediate = IMMEDIATE_TYPES.has(question.type);
  return (
    <Component
      question={question}
      value={value}
      error={error}
      readOnly={readOnly}
      showRequired={showRequired}
      onChange={(next, meta) =>
        onChange(next, { immediate: meta?.immediate ?? immediate, uploading: Boolean(meta?.uploading) })
      }
    />
  );
}
